import { MonoTypeOperatorFunction, skip } from 'rxjs';

export const skipOne: <Input>() => MonoTypeOperatorFunction<Input> = <T>() =>
  skip<T>(1);
